import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Customers extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Customers";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      type: 'COMPANY',
      id_customer: null,
      id_account: null,
      id_external: null,
      id_profile: null,
      logo_url: null,
      badge_url: null,
      rating: 5,
      region: null,
      district: null,
      default_phone: {
        name: 'Default Phone',
        number: null,
        extension: null,
        country: store.state.config.default_country,
        flag: store.state.config.default_country.flag,
        dial_code: store.state.config.default_country.dial_code,
        country_code: store.state.config.default_country.country_code,
        country_name: store.state.config.default_country.country_name,
        mask: store.state.config.default_country.phone_mask,
      },
      default_email: {
        name: 'Default Email',
        address: null,
      },
      meta_data: {},
      custom_fields: [],
      addresses: [], // temp
      contacts: [], // temp
      companies: [], // temp
      meta_key: null, // temp
      meta_value: null, // temp
      parent_id: null, // temp
      child_id: null, // temp
      online: {
        website: null,
        facebook: null,
        twitter: null,
        instagram: null,
        pinterest: null,
        linkedin: null,
      },
      vault_cards: [],
      vault_banks: [],
      tags: [],
      notes: [],
      note: {
        id: null,
        subject: null,
        body: null,
        created_by: null,
        created_at: null,
        is_private: false,
      },
      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    // if (process.env.NODE_ENV !== 'production') console.log("CUSTOMER MODEL", data);

    if (data.default_address) {
      data.default_address = new models.api.Addresses(data.default_address);
    }

    if (data.billing_address) {
      data.billing_address = new models.api.Addresses(data.billing_address);
    }

    if (data.shipping_address) {
      data.shipping_address = new models.api.Addresses(data.shipping_address);
    }

    if (data.default_phone) {
      data.default_phone = new models.api.Phones(data.default_phone);
    } 

    if (data.default_email) {
      data.default_email = new models.api.Emails(data.default_email);
    }

    if (data.contacts && data.contacts.length > 0) {
      data.contacts.map(async (contact) => {
        contact = new models.api.Customers(contact);
      });
    }

    if (data.companies && data.companies.length > 0) {
      data.companies.map(async (company) => {
        company = new models.api.Customers(company);
      });
    }

    if (data.addresses && data.addresses.length > 0) {
      data.addresses.map(async (address) => {
        address = new models.api.Addresses(address);
      });
    }

    if (data.vault_cards && data.vault_cards.length > 0) {
      data.vault_cards.map(async (card) => {
        card = new models.api.VaultCards(card);
      });
    }

    if (data.vault_banks && data.vault_banks.length > 0) {
      data.vault_banks.map(async (ach) => {
        ach = new models.api.VaultBanks(ach);
      });
    }

    if (data.vault_pii && data.vault_pii.length > 0) {
      data.vault_pii.map(async (pii) => {
        pii = new models.api.VaultPii(pii);
      });
    }
    return data;
  }
}
